export interface GeoState {
  isRegulated: boolean | null;
  country: string | null;
  loading: boolean;
  error: any;
  lastChecked: number | null;
  cacheExpiry: number; // 24 hours in milliseconds
}

export const initialGeoState: GeoState = {
  isRegulated: null,
  country: null,
  loading: false,
  error: null,
  lastChecked: null,
  cacheExpiry: 24 * 60 * 60 * 1000 // 24 hours
};